import { useContext } from 'react'
import { UpsellingContext } from '../context/upsellingContext'

export const useUpselling = () => useContext(UpsellingContext)
